import React, { useState } from "react";
import img from "../../assets/images/yzqf/yzqfbg.jpg";
import "./index.scss";
import TalkShade from "./talkShade";
import QSGC from "./QSGC";
import GoSecond from "./goSecond";
import StudyRoom from "./studyRoom";
import Des from "./des";
import GLP from "./GLP";
export default function YZQF({ setToPage }) {
  const [show, setShow] = useState();
  return (
    <div className="yzqf-page common-page animate__animated animate__fadeIn  ">
      <img src={img} alt="" />
      <div
        className="talkbtn talk animate__animated animate__pulse animate__faster	 animate__infinite"
        onClick={() => {
          setShow("talk");
        }}
      ></div>

      <div
        className="talkbtn tosecend  animate__animated animate__pulse animate__faster	 animate__infinite"
        onClick={() => {
          setShow("gosecond");
        }}
      ></div>
      <div
        className="gosecondbtn"
        onClick={() => {
          setShow("studyroom");
        }}
      ></div>
      <div
        className="bjjs-btn"
        onClick={() => {
          setShow("bjjs");
        }}
      ></div>
      {/* 简介 */}
      {show === "bjjs" && <Des setShow={setShow} />}
      {/* 对话 */}
      {show === "talk" && <TalkShade setShow={setShow} />}
      {/*  琴史钩沉*/}
      {show === "qsgc" && <QSGC setShow={setShow} />}

      {/* 去二楼对话 */}
      {show === "gosecond" && <GoSecond setShow={setShow} />}
      {/* 书房 */}
      {show === "studyroom" && <StudyRoom setShow={setShow} />}
      {show === "glp" && <GLP setShow={setShow} />}
      <div
        className="back"
        onClick={() => {
          setToPage();
        }}
      ></div>
    </div>
  );
}
